import { createAppInsertSchema } from '../../utils/schema';
import * as schema from '@strength/db-schema';
import { schemaToModelChange } from '../../utils/schema';
import { zWorkoutLayer } from '../../workout/layer';
import { z } from 'zod';
export var AthleteModifiedPublishedWorkoutDomain;
(function (AthleteModifiedPublishedWorkoutDomain) {
    AthleteModifiedPublishedWorkoutDomain.Module = 'AthleteModifiedPublishedWorkout';
    AthleteModifiedPublishedWorkoutDomain.zEdit = schemaToModelChange('AthleteModifiedPublishedWorkoutLayer', createAppInsertSchema(schema.AthleteModifiedPublishedWorkoutLayer)
        .omit({
        blockId: true,
        profileId: true,
        workoutId: true,
        athleteVersion: true,
        blockVersion: true,
    })
        .extend({
        // `createInsertSchema` doesn't handle the layer type very well
        layer: zWorkoutLayer,
    }));
    const zIdentity = z.object({
        blockId: z.uuid(),
        profileId: z.uuid(),
        workoutId: z.uuid(),
        athleteVersion: z.number(),
        blockVersion: z.number(),
    });
    AthleteModifiedPublishedWorkoutDomain.zCommand = z.object({
        module: z.literal(AthleteModifiedPublishedWorkoutDomain.Module),
        identity: zIdentity,
        edits: AthleteModifiedPublishedWorkoutDomain.zEdit.array(),
    });
})(AthleteModifiedPublishedWorkoutDomain || (AthleteModifiedPublishedWorkoutDomain = {}));
//# sourceMappingURL=domain.js.map